import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../assets/logo-without_background.webp'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, [
  /*#__PURE__*/_createTextVNode("Ahoj vodáci a všichni kdo vyznáváte aktivní využití volného času. Doba kovidová pominula (doufejme) a tak tu máme opět novou nabídku pěkných akcí. Lyže, sjezdy pěkných řek, i moře a potápění. Je už jen na vašem rozhodnutí, co si vyberete. Těšíme se na vás. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("Váš "),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    height: "100"
  })
], -1)

import CommonPage from "@/components/CommonPage.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'HomeView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CommonPage, { title: "Úvod" }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})